import { render, staticRenderFns } from "./doctorChoice.vue?vue&type=template&id=6649b893&"
import script from "./doctorChoice.vue?vue&type=script&lang=js&"
export * from "./doctorChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports